/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if (this.parent) {
						this.parent.classList.add('product-recommendations--full');

						if (document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

					// Inicializa lógica de bundle (checkboxes, totais e botão "comprar todos")
					this.initBundle();

				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		if (this.dataset.useMetafieldRecommendations === 'true') {
			this.initBundle();
			this.classList.add('product-recommendations--loaded');
			return;
		}
		this.fetchProducts();
	}
	initBundle() {
		const bundleContainer = this.querySelector('[data-bundle-container]');
		if (!bundleContainer) {
			return;
		}

		this.bundleItems = Array.from(bundleContainer.querySelectorAll('.bundle-item'));
		this.bundleCheckboxes = Array.from(bundleContainer.querySelectorAll('.bundle-item-checkbox'));
		this.bundleSummary = bundleContainer.querySelector('[data-bundle-summary]');
		this.bundlePriceOldEl = bundleContainer.querySelector('[data-bundle-price-old]');
		this.bundlePriceNewEl = bundleContainer.querySelector('[data-bundle-price-new]');
		this.bundleAddButton = bundleContainer.querySelector('[data-bundle-add]');

		if (!this.bundleItems.length || !this.bundleSummary || !this.bundleAddButton) {
			return;
		}

		// Eventos de alteração de seleção
		this.bundleCheckboxes.forEach((checkbox) => {
			checkbox.addEventListener('change', () => {
				this.updateCardItem(checkbox);
				this.updateBundleTotals();
			});
		});

		// Atualiza dados da variante do card ao passar o mouse no swatch.
		this.bindSwatchHoverUpdates(bundleContainer);

		// Clique no botão "adicionar selecionados"
		this.bundleAddButton.addEventListener('click', () => {
			this.addSelectedToCart();
		});

		// Calcula totais iniciais
		this.updateBundleTotals();
	}

	bindSwatchHoverUpdates(bundleContainer) {
		const swatches = bundleContainer.querySelectorAll('.product-card-swatch');
		if (!swatches.length) {
			return;
		}

		swatches.forEach((swatch) => {
			swatch.addEventListener('mouseover', () => {
				this.updateBundleItemFromSwatch(swatch);
			});
		});
	}

	updateBundleItemFromSwatch(swatch) {
		const cardItem = swatch.closest('.bundle-item');
		if (!cardItem) {
			return;
		}

		const variantId = swatch.dataset.variantId;
		const price = swatch.dataset.price;
		const compareAtPrice = swatch.dataset.compareAtPrice;
		const available = swatch.dataset.available;

		if (!variantId || price == null || compareAtPrice == null || available == null) {
			return;
		}

		cardItem.dataset.variantId = variantId;
		cardItem.dataset.price = price;
		cardItem.dataset.compareAtPrice = compareAtPrice;
		cardItem.dataset.available = available;
		cardItem.dataset.productChildrens = swatch.dataset.productChildrens || '';

		this.updateBundleTotals();
	}

	updateCardItem(checkbox) {
		this.cardItem = checkbox.closest('.bundle-item');
		this.cardItem.classList.toggle('selected', checkbox.checked);
		this.updateSelectedImagesStrip(checkbox);
	}

	updateSelectedImagesStrip(checkbox) {
		const strip = this.querySelector('[data-selected-images]');
		if (!strip) return;
		const index = this.bundleCheckboxes.indexOf(checkbox);
		if (index < 0) return;
		const slot = strip.querySelector(`.product-recommendations__selected-image-item[data-bundle-index="${index}"]`);
		if (slot) {
			slot.classList.toggle('is-visible', checkbox.checked);
		}
	}

	updateBundleTotals() {
		if (!this.bundleItems || !this.bundleItems.length) {
			return;
		}

		let totalPrice = 0;
		let totalCompareAt = 0;
		let selectedCount = 0;

		this.bundleItems.forEach((item, index) => {
			const checkbox = this.bundleCheckboxes[index];
			if (!checkbox || !checkbox.checked) {
				return;
			}

			const price = parseInt(item.dataset.price, 10) || 0;
			const compareAtPrice = parseInt(item.dataset.compareAtPrice, 10);

			totalPrice += price;

			if (!isNaN(compareAtPrice) && compareAtPrice > 0) {
				// Se tiver compare_at_price válido, usamos ele como "preço antigo" desse item.
				totalCompareAt += compareAtPrice;
			} else {
				// Caso contrário, o preço antigo é o próprio preço atual.
				totalCompareAt += price;
			}

			selectedCount += 1;
		});

		// Habilita/desabilita botão
		this.bundleAddButton.disabled = selectedCount === 0;

		if (selectedCount === 0) {
			if (this.bundlePriceOldEl) this.bundlePriceOldEl.textContent = '';
			if (this.bundlePriceNewEl) this.bundlePriceNewEl.textContent = '';
			return;
		}

		const hasDiscount = totalCompareAt > totalPrice;

		if (this.bundlePriceOldEl) {
			this.bundlePriceOldEl.textContent = hasDiscount ? this.formatMoney(totalCompareAt) : '';
			this.bundlePriceOldEl.style.display = hasDiscount ? '' : 'none';
		}

		if (this.bundlePriceNewEl) {
			this.bundlePriceNewEl.textContent = this.formatMoney(totalPrice);
		}
	}
	getSelectedItems() {
		const items = [];

		if (!this.bundleItems || !this.bundleItems.length) {
			return items;
		}

		this.bundleItems.forEach((item, index) => {
			const checkbox = this.bundleCheckboxes[index];
			if (!checkbox || !checkbox.checked) {
				return;
			}

			const variantId = item.dataset.variantId;
			if (!variantId) {
				return;
			}

			items.push({
				id: parseInt(variantId, 10),
				quantity: 1
			});
		});

		return items;
	}
	buildVariantIdsParam(variantId, productChildrensRaw) {
		const currentId = String(variantId);
		const toGid = (value) => {
			const normalized = String(value || '').trim();
			if (!normalized) return null;
			if (normalized.startsWith('gid://shopify/ProductVariant/')) return normalized;
			return `gid://shopify/ProductVariant/${normalized}`;
		};

		let productChildrens = [];
		const raw = String(productChildrensRaw || '').trim();

		if (raw) {
			try {
				const parsed = JSON.parse(raw);
				if (Array.isArray(parsed)) {
					productChildrens = parsed
						.map((entry) => (typeof entry === 'object' ? entry?.id ?? entry?.shopifyId : entry))
						.map(toGid)
						.filter(Boolean);
				}
			} catch (error) {
				productChildrens = raw
					.split(',')
					.map((id) => toGid(id))
					.filter(Boolean);
			}
		}

		if (!productChildrens.length) {
			return toGid(currentId);
		}

		return productChildrens.join(',');
	}

	async getPreOrderDataForVariant(variantId, productHandle, variantIdsParam) {
		const gidVariantId = `gid://shopify/ProductVariant/${variantId}`;
		const variantIds = variantIdsParam || gidVariantId;
		const url = `https://taiwan-lab-85r95.ondigitalocean.app/api/get-product?variantIds=${variantIds}&variantId=${gidVariantId}`;

		try {
			const response = await fetch(url);
			const preOrderData = await response.json();
			const productParent = preOrderData?.productParent;

			// PDP parity fallback:
			// if bundle metadata does not provide product_childrens and API returns empty result
			// for a parent variant, retry using productParent.productChildren shopifyChildId list.
			if (
				Array.isArray(preOrderData?.result) &&
				preOrderData.result.length === 0 &&
				Array.isArray(productParent?.productChildren) &&
				productParent.productChildren.length > 0
			) {
				const fallbackVariantIds = productParent.productChildren
					.map((child) => child?.shopifyChildId)
					.filter(Boolean)
					.join(',');

				if (fallbackVariantIds) {
					const fallbackUrl = `https://taiwan-lab-85r95.ondigitalocean.app/api/get-product?variantIds=${fallbackVariantIds}&variantId=${gidVariantId}`;
					const fallbackResponse = await fetch(fallbackUrl);
					const fallbackData = await fallbackResponse.json();

					if (fallbackData && typeof fallbackData === 'object') {
						Object.assign(preOrderData, fallbackData);
					}
				}
			}

			if (productParent && preOrderData?.result) {
				preOrderData.result = preOrderData.result.map((entry) => ({
					...entry,
					parentProduct: productParent
				}));
			}

			if (typeof window.findEarliestValidContainerItem === 'function') {
				const match = window.findEarliestValidContainerItem(preOrderData?.result, variantIds, productHandle);
				return match;
			}

			const items = Array.isArray(preOrderData?.result) ? preOrderData.result : [];
			const fallbackMatch = items.find((entry) => entry?.template) || null;
			return fallbackMatch;
		} catch (error) {
			console.error('Error fetching pre-order data for bundle item:', error);
			return null;
		}
	}

	isPreOrderActive(data) {
		if (!data) return false;

		const now = new Date();
		if (data.startDate) {
			const startDate = new Date(data.startDate);
			if (startDate > now) return false;
		}

		if (data.endDate) {
			const endDate = new Date(data.endDate);
			if (endDate < now) return false;
		}

		return true;
	}

	localizePreOrderField(value) {
		if (!value) return value;
		const locale = (window.Shopify?.locale || 'en').toLowerCase();
		const localeKey = locale === 'zh-tw' ? 'CH' : 'EN';

		try {
			const parsed = typeof value === 'string' ? JSON.parse(value) : value;
			if (parsed && typeof parsed === 'object') {
				return parsed[localeKey] ?? parsed.EN ?? value;
			}
		} catch (error) {
			// Keep raw value when it is not a localized JSON payload.
		}

		return value;
	}

	buildPreOrderProperties(preOrderData) {
		const settings = preOrderData?.template?.cartPreOrderSettings;
		const titleRaw = settings?.title || 'Pre-order item';
		const labelRaw = settings?.label || 'Pre-order';

		const title = String(this.localizePreOrderField(titleRaw) || 'Pre-order item').trim();
		const label = String(this.localizePreOrderField(labelRaw) || 'Pre-order').trim();

		return {
			[title || 'Pre-order item']: label || 'Pre-order'
		};
	}

	async getSelectedItemsWithPreOrder() {
		const selectedItems = this.getSelectedItems();
		if (!selectedItems.length) return selectedItems;

		const lookup = new Map();
		this.bundleItems.forEach((bundleItem, index) => {
			const checkbox = this.bundleCheckboxes[index];
			if (!checkbox?.checked) return;

			const variantId = parseInt(bundleItem.dataset.variantId, 10);
			if (!variantId) return;

			lookup.set(variantId, {
				productHandle: bundleItem.dataset.productHandle || '',
				productChildrens: bundleItem.dataset.productChildrens || ''
			});
		});

		const items = await Promise.all(
			selectedItems.map(async (item) => {
				const bundleMetadata = lookup.get(item.id) || {};
				const recommendationMapEntry = window.recommendationProductChildrens?.[item.id] || {};
				const productHandle = bundleMetadata.productHandle || recommendationMapEntry.productHandle || null;
				const productChildrensSource = bundleMetadata.productChildrens || recommendationMapEntry.product_childrens || '';
				const variantIds = this.buildVariantIdsParam(item.id, productChildrensSource);
				const preOrderData = await this.getPreOrderDataForVariant(item.id, productHandle, variantIds);
				const shouldShowPreOrder = !!(preOrderData?.template && this.isPreOrderActive(preOrderData));

				if (!shouldShowPreOrder) return item;

				const properties = this.buildPreOrderProperties(preOrderData);
				if (!properties) return item;

				return {
					...item,
					properties
				};
			})
		);

		return items;
	}

	async addSelectedToCart() {
		this.bundleAddButton.classList.add('loading');

		const items = await this.getSelectedItemsWithPreOrder();
		if (!items.length) {
			this.bundleAddButton.classList.remove('loading');
			return;
		}

		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			body: JSON.stringify({ items })
		})
			.then(response => response.json())
			.then(() => {
				dispatchCustomEvent('cart:refresh');

				const cartDrawer = document.getElementById('Cart-Drawer');
				if (cartDrawer) {
					document.body.classList.add('open-cc');
					document.body.classList.add('open-cart');
					cartDrawer.classList.add('active');
					cartDrawer.focus();
					cartDrawer.querySelector('.product-recommendations--full')?.classList.add('active');
					dispatchCustomEvent('cart-drawer:open');
				}

				dispatchCustomEvent('cart:item-added', {
					product: items[0]
				});
			})
			.catch((e) => {
				console.error(e);
			})
			.finally(() => {
				this.bundleAddButton.classList.remove('loading');
			});
	}
	formatMoney(cents) {
		if (cents == null || isNaN(cents)) return '';
		const value = cents / 100;
		const currencyCode = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active)
			? Shopify.currency.active
			: 'USD';
		const locale = (typeof Shopify !== 'undefined' && Shopify.locale)
			? Shopify.locale
			: 'en';
		try {
			return new Intl.NumberFormat(locale, {
				style: 'currency',
				currency: currencyCode,
				minimumFractionDigits: 0,
				maximumFractionDigits: 0
			}).format(value);
		} catch (e) {
			return '$' + Math.round(value);
		}
	}
}

customElements.define('product-recommendations', ProductRecommendations);
